import React from 'react';
import { notification } from 'antd/lib';

import { graphql, compose, withApollo } from 'react-apollo';

import Loading from '../../common/Loading';

import CKEditor from '../../editor/Example';
import { imprimir } from '../../common/funciones/imprimir';
import updateOficioPorId from '../../../graphql/mutations/tramites/updateOficioPorId.graphql';
import getOficioPorId from '../../../graphql/querys/tramites/getOficioPorId.graphql';
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';

import { errorService } from '../../../graphql/utils/utils';

@compose(
  graphql(updateOficioPorId, {
    name: 'updateOficioPorId',
  }),
  graphql(getUsuario, {
    name: 'getUsuario',
  }),
  graphql(getOficioPorId, {
    options: props => ({
      variables: {
        _id: props.match.params.id,
      },
      fetchPolicy: 'network-only',
    }),
  })
)
class EditarOficio extends React.Component {
  state = {
    persona: {},
    step: 0,
    textoNota: '',
    guardado: false,
    loading: true,
  };

  onCancel = () => {
    this.setState(
      {
        fase: 0,
      },
      () => {
        this.props.history.goBack();
      }
    );
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    // console.log('THIS PROPS: ', this.props);
    // console.log('NEXT PROPS: ', nextProps);
    if (
      (!this.props.data.getOficioPorId || this.props.data.loading) &&
      nextProps.data.getOficioPorId
    ) {
      if (!nextProps.data.getOficioPorId.textoNota) {
        this.props.history.goBack();
      } else {
        this.setState({
          Oficio: nextProps.data.getOficioPorId,
          textoNota: nextProps.data.getOficioPorId.textoNota,
          loading: false,
        });
      }
    }
  }

  onGuardar = html => {
    // console.log('Tengo que guardar...');
    // console.log(html);

    this.setState({
      loading: true,
    });
    this.props
      .updateOficioPorId({
        variables: {
          _id: this.state.Oficio._id,
          nuevoOficio: {
            textoNota: html,
          },
        },
      })
      .then(res => {
        // console.log('Respuesta del actuaciolizar');
        // console.log(res);

        if (res.data.updateOficioPorId) {
          notification.success({
            message: 'Documento Independiente Modificado',
            description: 'El Documento Independiente se modificó correctamente',
          });

          this.setState({
            loading: false,
          });
          this.props.history.goBack();
        }
      })
      .catch(err => {
        console.log('Se ha producido un error');
        console.log(err);
        errorService(err, {
          _id: this.state.Oficio._id,
          nuevoOficio: {
            textoNota: html,
          },
        });
        notification.error({
          message: 'Error al actualizar el Documento Independiente',
          description:
            'Se ha producido un error al actualizar el Documento Independiente',
        });
        this.setState({
          loading: false,
        });
      });
  };

  render() {
    if (this.state.loading) {
      return <Loading />;
    }

    // console.log('DATOS:');
    // console.log(this.state);
    // console.log(this.props);

    return (
      <div>
        <CKEditor
          modelo_nota={{ htmlModelo: this.state.textoNota }}
          onImprimir={imprimir}
          onGuardar={this.onGuardar}
          onCancel={this.onCancel}
          accion="visualizar"
        />
      </div>
    );
  }
}

export default withApollo(EditarOficio);
